export default __webpack_public_path__ + "images/4e960bbec3f78420ee5367da236b85a1-dating_tablet_1_1067x312.webp";